export const CampaignColors = [
    {
        key: "orange",
        label: "constants.colors.orange",
        value: "#FFBF00"
    },
    {
        key: "green",
        label: "constants.colors.green",
        value: "#8DCE00"
    },
    {
        key: "blue",
        label: "constants.colors.blue",
        value: "#20CCCC"
    },
    {
        key: "pink",
        label: "constants.colors.pink",
        value: "#DD0EC8"
    }
]